import { createSelector } from 'reselect';
import {
    ITALIC_START, ITALIC_END, BOLD_START, BOLD_END, TRC_BREAK,
} from '../constants/regExp';

export const getTRCPages = (state) => state.pages;

export const getTRCImageURLs = createSelector(
    getTRCPages,
    (pages) => {
        return pages.reduce((acc, page) => {
            if (page.picture && page.picture.url) {
                acc.push(page.picture.url);
            }

            return acc;
        }, []);
    }
);

export const getNumPages = createSelector(
    getTRCPages,
    (pages) => pages.length,
);

export const getTRCBookTitle = (state) => state.title;

export const getTRCComprehensionItems = (state) => state.comprehensionItems;

export const getIsBookIndented = (state) => state.indented;

export const getBookIntroAudio = (state) => state.introAudio;

export const getNumTRCComprehensionItems = createSelector(
    [getTRCComprehensionItems],
    (comprehensionItems) => comprehensionItems.length,
);

export const getTRCComprehensionItem = (state, questionIndex) => state.comprehensionItems[questionIndex];

export const getTRCBookCover = (state) => state.cover;

export const getTRCBookCoverAltText = (state) => state.coverAltText;

export const getTRCBookGenre = (state) => state.genre;

export const getTRCBookRelativeLevel = (state) => state.relativeLevel;

export const getActiveTRCPage = (state) => state.activePage;

export const getTRCPagesViewed = (state) => state.pagesViewed;

export const getLastRecordedPage = (state) => state.lastRecordedPage;

export const isFirstTRCPage = createSelector(
    getActiveTRCPage,
    (activePage) => activePage === 0,
);

export const isLastTRCPage = (state) => getActiveTRCPage(state) + 1 >= getNumPages(state);

export const getTRCBookId = (state) => state.id;

const processText = text => (text
    .replace(ITALIC_START, '')
    .replace(ITALIC_END, '')
    .replace(BOLD_START, '')
    .replace(BOLD_END, '')
    .replace(TRC_BREAK, ' ')
    .replace('GRA-A-A-A-CK', 'Grack')
    .replace('Good-bye', 'Goodbye')
);

const flattenPages = (pages) => {
    return pages.reduce((acc, value) => {
        const { paragraphs } = value;
        if (paragraphs) {
            const firstParagraphIndex = 0;
            let paragraphGrouping = '';
            paragraphs.forEach((paragraph, index) => {
                if (index === firstParagraphIndex) {
                    paragraphGrouping += paragraph.text;
                } else {
                    paragraphGrouping += ` ${  paragraph.text}`;
                }
            });
            acc.push(paragraphGrouping);
        }
        return acc;
    }, []);
};

const getReadPages = (pages, lastRecordedPage) => {
    const firstRecordedPage = 0;

    return pages.filter(
        (element, index) =>
            index <= lastRecordedPage && index >= firstRecordedPage);
};

export const getReadTRCBookText = createSelector(
    getTRCPages,
    getLastRecordedPage,
    (pages, lastRecordedPage) => {
        const filteredPages = getReadPages(pages, lastRecordedPage);
        const flattenedPages = flattenPages(filteredPages);
        const fullReadText = flattenedPages.join(' ');
        const processedText = processText(fullReadText);
        return processedText;
    }
);

export const getLastWordIndex = createSelector(
    getTRCPages,
    getLastRecordedPage,
    (pages, lastRecordedPage) => {
        return pages[lastRecordedPage].lastWordIndexOnPage;
    }
);
